import {ProcessActions, SECONDS_IN_HOUR, SECONDS_IN_MINUTE} from '../../constants/constants';
import {claimProcess, reclaimProcess, discardProcess} from '../../api/processes';
import {Assignee} from '../../constants/types';
import {processActions, MAX_USERS_TO_CLAIM_PROCESS} from './constants';
import {shouldShowClaimButtonProps} from './types';

export const calculateAndFormatTimeMMSS = (
    timeInSeconds: Nullable<number>,
    showSeconds=true
) => {
  if (timeInSeconds === 0) return '0 m';
  if (!timeInSeconds) return '';

  const minutes = Math.floor(
      Math.abs(Number(timeInSeconds)) / SECONDS_IN_MINUTE
  );
  const seconds = Math.floor(
      Math.abs(Number(timeInSeconds)) % SECONDS_IN_MINUTE
  );

  return `${minutes}m` + `${seconds && showSeconds ? ` ${seconds}s` : ''}`;
};

export const calculateAndFormatTimeHHMMSS =
(timeInSeconds: number) => {
  const hours = Math.floor(Math.abs(timeInSeconds) / SECONDS_IN_HOUR);

  const minutes =
  ('0' + Math.floor(
      (Math.abs(timeInSeconds) - hours * SECONDS_IN_HOUR) / SECONDS_IN_MINUTE
  )).slice(-2);

  const seconds = ('0' + Math.floor(Math.abs(timeInSeconds) % SECONDS_IN_MINUTE)).slice(-2);

  return `${hours}:${minutes}:${seconds}`;
};

export const calculateAndFormatTimeHHMM =
(timeInSeconds: number,
    expired?: boolean) => {
  if (timeInSeconds < 0) return null;

  const hours = Math.floor(Math.abs(timeInSeconds) / SECONDS_IN_HOUR);

  const minutes =
  Math.floor(
      (Math.abs(timeInSeconds) - hours * SECONDS_IN_HOUR) / SECONDS_IN_MINUTE
  );

  if (!hours && !minutes && expired) return null;

  return `${hours ? `${hours}h` : ''} ${minutes}m`;
};


export const startProcessAction = (
    id: number,
    processAction: ProcessActions,
    assigneeId: number
) => {
  switch (processAction) {
    case ProcessActions.CLAIM:
      return claimProcess(id);
    case ProcessActions.DISCARD:
      return discardProcess(id);
    case ProcessActions.RECLAIM:
      return reclaimProcess(id, assigneeId);
    default:
      return '';
  }
};

const getProcessActionsButtonOptions = (
    assignees: Assignee[], processAction: ProcessActions
) => {
  const showMainOptionButton = !!assignees.length &&
  processAction !== ProcessActions.RECLAIM;

  return {
    mainOption: processActions[processAction],
    showMainOptionButton: showMainOptionButton,
    otherOptions: assignees.map((assignee) => {
      return {
        name: `${processActions[processAction].optionElementName} ${assignee.firstName} ${assignee.lastName}`,
        onClick: processActions[processAction].optionElementOnClick,
        assigneeId: assignee.id,
        disabled: processActions[processAction].optionElementDisabled
      };
    }),
    processActionType: processAction
  };
};

export const getProcessClaimingButtonOptions = (
    assignees: Assignee[], currentUserId: Nullable<number>
) => {
  if (assignees) {
    if (assignees?.find((user) => user.id === currentUserId)) {
      return getProcessActionsButtonOptions(
          assignees.filter((assignee) => assignee.id !== currentUserId),
          ProcessActions.DISCARD
      );
    }

    if (assignees.length >= MAX_USERS_TO_CLAIM_PROCESS) {
      return getProcessActionsButtonOptions(assignees, ProcessActions.RECLAIM);
    }
  }

  return getProcessActionsButtonOptions(assignees, ProcessActions.CLAIM);
};

export const shouldShowProcessClaimingButton = ({
  availableProcessAssigneeGroups, userGroups
}: shouldShowClaimButtonProps): boolean => (
  !!(availableProcessAssigneeGroups?.filter((group) =>
    userGroups?.includes(group.slug)).length)
);
